import { el } from '../ui/dom.js';

/** Sous-titre court (accessibilité / fallback) — le détail est dans l’intro. */
export const BOARD_WARMUP_SUBTITLE =
  'Avant la manche : un tour sur le plateau, avec votre monnaie de saison.';

export const BOARD_WARMUP_INTRO_LEAD =
  'Avant chaque manche, le circuit devient un plateau. Chaque pilote lance le dé à son tour (ordre de grille) et avance case par case : bonus, malus, améliorations ou casino.';

export const BOARD_WARMUP_INTRO_CURRENCY =
  'Monnaie (chiffre à droite de chaque nom) : c’est votre budget de saison. Elle sert uniquement à payer — ou à éviter — les effets des cases. Ce n’est pas un score de course.';

export const BOARD_WARMUP_INTRO_RANKING =
  'Points de classement : ceux du championnat, gagnés après la course (places, dépassements…). Le tour de chauffe n’en attribue aucun.';

/** Bloc d’explication lisible sous le titre « Tour de chauffe ». */
export function createBoardWarmupIntro(): HTMLElement {
  const intro = el('aside', {
    class: 'board-warmup-intro',
    role: 'note',
    'aria-label': 'Règles du tour de chauffe',
  });
  intro.appendChild(el('p', { class: 'board-warmup-intro__lead', text: BOARD_WARMUP_INTRO_LEAD }));
  const list = el('ul', { class: 'board-warmup-intro__list' });
  list.appendChild(el('li', { text: BOARD_WARMUP_INTRO_CURRENCY }));
  list.appendChild(el('li', { text: BOARD_WARMUP_INTRO_RANKING }));
  intro.appendChild(list);
  return intro;
}
